<p-dialog
    header="{{ 'page.column-visibility.title' | translate }}"
    [modal]="true"
    [closable]="true"
    [(visible)]="visible"
    appendTo="body"
    [style]="{ width: '30rem', height: '35rem' }"
    [contentStyle]="{ overflow: 'auto' }"
    (onHide)="saveColumnVisibility()">

    @if (columns?.length > 0) {
        @if (modalService.getVisibleColumnCount(columns) >= columnsMax) {
            <div class="alert alert-info py-2">
                <small>{{ 'page.column-visibility.max-columns' | translate: {nbColumns: columnsMax} }}</small>
            </div>
        }
        @for (col of columns; track col) {
            <div class="field-checkbox mb-2">
                <p-checkbox
                    [ngModel]="col.visible"
                    [binary]="true"
                    (onChange)="toggleColumnVisibility(col.field)"
                    [disabled]="!col.visible && modalService.getVisibleColumnCount(columns) >= columnsMax"
                    inputId="{{ col.field }}"
                    name="{{ col.field }}">
                </p-checkbox>
                <label [for]="col.field" class="ms-2">{{ col.label | translate }}</label>
            </div>
        }
    }
</p-dialog>
